module.exports = __webpack_public_path__ + "static/media/03.01756c96.jpg";